import { memo } from 'react';
import { withRole } from '../Common/withRole';
import { DangerButton } from '../Common/BaseButton';
import { Trash2 } from 'lucide-react';

const RemoveButtonContent = memo(({ onRemove, assignmentId }) => (
  <DangerButton 
    aria-label="Remove team member" 
    title="Remove from event" 
    onClick={() => onRemove(assignmentId)}
  >
    <Trash2 size={16} />
  </DangerButton>
));

const WithRoleRemoveButton = withRole(RemoveButtonContent, { 
  managerOnly: true
});

const DeleteTeamMemberButton = memo(({ onRemove, assignmentId, isManager, isAuthenticated }) => {
  
  return (
    <WithRoleRemoveButton 
      isManager={isManager}
      isAuthenticated={isAuthenticated}
      onRemove={onRemove}
      assignmentId={assignmentId}
    />
  );
});

export default DeleteTeamMemberButton;